import { render, staticRenderFns } from "./SwipeActions.vue?vue&type=template&id=1f5cae16&scoped=true"
import script from "./SwipeActions.vue?vue&type=script&lang=js"
export * from "./SwipeActions.vue?vue&type=script&lang=js"
import style0 from "./SwipeActions.vue?vue&type=style&index=0&id=1f5cae16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cae16",
  null
  
)

export default component.exports